<template>
  <v-toolbar class="primary ml-0" dark fixed clipped-left clipped-right app extension-height="0">
    <v-toolbar-side-icon @click.stop="toggleDrawer()"></v-toolbar-side-icon>
    <v-toolbar-title class="mr-5 align-center" @click="$router.push('/')">
      <span class="title">
        Audit.Cloud
        <sup class="theme--dark accent--text" title="Beta Version">β</sup>
      </span>
    </v-toolbar-title>
    <span v-if="config.components.breadcrumb">
      <breadcrumb></breadcrumb>
    </span>
    <v-text-field
      v-if="config.components.search"
      flat
      solo-inverted
      prepend-icon="search"
      label="Search"
      class="hidden-sm-and-down"
    ></v-text-field>
    <v-spacer></v-spacer>
    <OfflineStatus />
    <v-btn v-if="config.components.reload" icon dark @click="reloadApp">
      <v-icon dark>refresh</v-icon>
    </v-btn>
    <v-btn icon @click="openActivitiyStream()">
      <v-badge overlap color="red" v-if="currentActivities">
        <span slot="badge">{{ currentActivities }}</span>
        <v-icon>notifications</v-icon>
      </v-badge>
      <v-icon v-else>notifications</v-icon>
    </v-btn>
    <v-menu bottom left :nudge-width="100">
      <v-btn slot="activator" icon large>
        <v-avatar v-if="isAuthenticated" size="32px" color="purple">
          <img v-if="$user.avatar()" :src="$user.avatar()" alt="Vuetify" />
          <span v-else class="white--text headline">{{ currentAvatar }}</span>
        </v-avatar>
      </v-btn>
      <v-list>
        <v-list-tile>
          <v-list-tile-avatar>
            <img v-if="isAuthenticated && $user.avatar()" :src="$user.avatar()" />
          </v-list-tile-avatar>
          <v-list-tile-title>{{ $user.displayName() }}</v-list-tile-title>
          <v-list-tile-action>
            <v-btn @click="editUser($user.id())" flat round>
              <v-icon>edit</v-icon>
            </v-btn>
          </v-list-tile-action>
        </v-list-tile>

        <v-divider></v-divider>
        <v-list-tile @click="changeLanguage()">
          <v-list-tile-action>
            <v-icon>language</v-icon>
          </v-list-tile-action>
          <v-list-tile-title>{{ $t("menu_panel_language") }}</v-list-tile-title>
        </v-list-tile>

        <template v-for="useraction in userActions">
          <v-list-tile v-if="useraction.text" :key="useraction.text" @click="logout()">
            <v-list-tile-action>
              <v-icon>{{ useraction.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ useraction.text }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-list-tile v-else :key="useraction.text" @click="$router.push(useraction.route)">
            <v-list-tile-action>
              <v-icon>{{ useraction.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ useraction.text }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </template>
      </v-list>
    </v-menu>
    <v-progress-linear
      pa-4
      v-if="isLoading"
      slot="extension"
      color="secondary"
      :indeterminate="true"
      class="ma-0"
      height="2"
    ></v-progress-linear>
  </v-toolbar>
</template>

<i18n>
  {
    "de" : {
      "menu_panel_language" : "Sprache: Englisch"
    },
    "en" : {
      "menu_panel_language" : "Language: German"
    }
  }
</i18n>

<script>
import { mapActions, mapGetters } from "vuex";
import { api } from "@/store/modules/activities";
import { api as appApi } from "@/store/modules/app";
import { api as confApi } from "@/store/modules/configuration";
import { api as userApi } from "@/store/modules/users";

import Breadcrumb from "@/components/app/Breadcrumb.vue";
import OfflineStatus from "@/components/app/OfflineStatus.vue";

export default {
  components: {
    Breadcrumb,
    OfflineStatus
  },
  computed: {
    ...mapGetters(api.namespace, [api.getters.newActivities]),
    ...mapGetters(confApi.namespace, [confApi.getters.app]),
    ...mapGetters(appApi.namespace, [
      appApi.getters.getCurrentLanguage,
      appApi.getters.isLoading
    ]),
    config() {
      console.log("App Config", this.app);
      return this.app || { components: { search: false } };
    },
    currentActivities() {
      return this.newActivities || "";
    },
    userActions() {
      if (this.$store.getters["users/isAuthenticated"]) {
        return [{ icon: "exit_to_app", text: "Sign out", route: "/signout" }];
      } else {
        return [{ icon: "lock_open", text: "Sign in", route: "/signin" }];
      }
    },
    currentAvatar() {
      if (this.$user.displayName()) {
        return this.$user.displayName().substring(0, 1) || "-";
      } else {
        return "-";
      }
    },
    isAuthenticated() {
      return this.$store.getters["users/isAuthenticated"];
    }
  },
  methods: {
    ...mapActions(appApi.namespace, [
      appApi.actions.reloadApp,
      appApi.actions.toggleDrawer,
      appApi.actions.toggleDrawerRight,
      appApi.actions.setDrawerRight,
      appApi.actions.setLanguage
    ]),
    ...mapActions(userApi.namespace, [userApi.actions.userSignOut]),
    logout() {
      console.log("Loging Out");
      this.userSignOut();
      this.$router.push("/signin");
    },
    changeLanguage() {
      const lang = this.getCurrentLanguage;
      console.log("changeLanguage", lang);
      if (lang === "en") {
        this.setLanguage("de");
      } else {
        this.setLanguage("en");
      }
      this.$i18n.locale = this.getCurrentLanguage;
    },
    editUser(user_id) {
      console.log("User editieren", user_id);
      this.$router.push("/users/" + user_id);
    },
    openActivitiyStream() {
      const payload = {
        component: "ActivityStream"
      };
      this.setDrawerRight(payload);
      this.toggleDrawerRight();
    }
  }
};
</script>
